import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function Contact() {
  return (
    <>
      {/* Simple Header */}
      <div className="container py-4" style={{ maxWidth: '1200px' }}>
        <nav aria-label="breadcrumb" className="mb-3">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to="/" className="text-decoration-none" style={{ color: 'var(--tgh-blue-light)' }}>
                Home
              </Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Contact
            </li>
          </ol>
        </nav>
        <h1 className="display-4 mb-0" style={{ fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#000' }}>
          Contact Us
        </h1>
      </div>

      {/* Main Content */}
      <div className="container py-5" style={{ maxWidth: '1200px' }}>
        {/* Contact Information Section */}
        <ScrollSection>
          <div className="row mb-5">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
                Get in Touch
              </h2>
              
              <div className="mb-4">
                <div className="d-flex align-items-start mb-3">
                  <div className="me-3" style={{ fontSize: '1.5rem', color: 'var(--tgh-blue-light)' }}>
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000', marginBottom: '0.5rem' }}>
                      Address
                    </h5>
                    <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                      P.O. Box 14,{' '}
                      <a 
                        href="https://maps.app.goo.gl/fYCxAzFS3JNGUKnNA" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}
                      >
                        Tema Community 12, Tema, Ghana
                      </a>
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-start mb-3">
                  <div className="me-3" style={{ fontSize: '1.5rem', color: 'var(--tgh-blue-light)' }}>
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000', marginBottom: '0.5rem' }}>
                      Phone
                    </h5>
                    <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: '0.25rem' }}>
                      <a href="tel:+233303302696" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>
                        +233 30-330-2696/7
                      </a>
                    </p>
                    <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                      Emergency: <a href="tel:0556700674" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>0556700674</a>
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-start">
                  <div className="me-3" style={{ fontSize: '1.5rem', color: 'var(--tgh-blue-light)' }}>
                    <i className="bi bi-envelope"></i>
                  </div>
                  <div>
                    <h5 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#000', marginBottom: '0.5rem' }}>
                      Email
                    </h5>
                    <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: '0.25rem' }}>
                      <a href="mailto:temageneral.ghgar@ghs.gov.gh" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>
                        temageneral.ghgar@ghs.gov.gh
                      </a>
                    </p>
                    <p style={{ fontSize: '1rem', color: '#333', lineHeight: '1.6', marginBottom: 0 }}>
                      <a href="mailto:temageneral2017@gmail.com" style={{ color: 'var(--tgh-blue-light)', textDecoration: 'none' }}>
                        temageneral2017@gmail.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-6">
              <h2 className="mb-4" style={{ fontSize: '2.5rem', fontWeight: 'bold', color: 'var(--tgh-blue-light)', lineHeight: '1.2', fontFamily: 'Georgia, serif' }}>
                Send us a Message
              </h2>
              <form>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label" style={{ fontSize: '1rem', fontWeight: '500', color: '#333' }}>
                    Name
                  </label>
                  <input 
                    type="text" 
                    className="form-control" 
                    id="name"
                    placeholder="Please enter your name" 
                    required
                    style={{ fontSize: '1rem', padding: '0.75rem', border: '1px solid #ddd', borderRadius: '4px' }}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label" style={{ fontSize: '1rem', fontWeight: '500', color: '#333' }}>
                    Email
                  </label>
                  <input 
                    type="email" 
                    className="form-control" 
                    id="email"
                    placeholder="Please enter your email" 
                    required
                    style={{ fontSize: '1rem', padding: '0.75rem', border: '1px solid #ddd', borderRadius: '4px' }}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label" style={{ fontSize: '1rem', fontWeight: '500', color: '#333' }}>
                    Message
                  </label>
                  <textarea 
                    className="form-control" 
                    id="message"
                    rows="5" 
                    placeholder="Please enter your message" 
                    required
                    style={{ fontSize: '1rem', padding: '0.75rem', border: '1px solid #ddd', borderRadius: '4px' }}
                  ></textarea>
                </div>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  style={{ 
                    backgroundColor: 'var(--tgh-blue-light)', 
                    borderColor: 'var(--tgh-blue-light)',
                    padding: '0.75rem 2rem',
                    fontSize: '1rem',
                    fontWeight: '500'
                  }}
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </ScrollSection>
      </div>
    </>
  );
}

export default Contact;
